export default defineNuxtRouteMiddleware(async (to, from) => {
  const { fetchDocument, fetchArchive, setCurrentModel } = useDocumentStore();
  const document = useState<any>('document');
  const currentModel = useState<any>('currentModel');

  const lastModel = currentModel.value || '';

  if (!(to.name as string).includes('documents') && !(to.name as string).includes('public-documents') || !to.params?.id) {
    return;
  }
  if (!(to.name as string).includes('public_documents')) {
    setCurrentModel('documents');
  } else {
    setCurrentModel('public_documents');
  }

  if (document.value && document.value._id === to.params.id && lastModel == currentModel.value) {
    return;
  }

  try {
    log('fetching document', currentModel.value, to.params.id);
    await fetchDocument(to.params.id as string);
    await fetchArchive();
  } catch (err) {
    console.error('Error in middleware:', err);
  }
});
